import React from "react";
import PropTypes from "prop-types";

// import css from 'cape-style'
import { filter, sampleSize, sample } from "lodash";
import marked from "marked";

import StudentInfo from "./StudentInfo";
import ProgramList from "./ProgramList";
import Wrapper from "../Wrapper/WrapperEl";
import ImageStackMobile from "./ImageStackMobile";
import Logo from "../Logo/Logo";
import Slideshow from "../Slideshow/SlideTest";
// import SlideThumb from "./SlideThumb";
import NoImages from "./NoImages";

import mgsLogo from "../../mgs2018logoarrow.svg";

import {
  Flex,
  ImageContainer,
  InfoContainer,
  Divider,
  Back,
  Loading,
  SlideTitle,
  Description,
  Essay,
} from "./styles";

function ProgramDetail({ closePopup, program, studentArt, allStudentArt }) {
  let picked = null;
  if (allStudentArt && allStudentArt.length > 0 && program && program.id) {
    const filtered = filter(allStudentArt, { program: program.id });
    picked = sampleSize(filtered, 12);
  }

  const profileImg =
    program && program.profileImage && sample(program.profileImage);
  console.log(program);

  return (
    <Wrapper>
      <Back onClick={closePopup}>
        <Logo primary left logoSrc={mgsLogo} siteName="MICA Grad Show 2022" />
      </Back>
      {!program && <Loading className="flex loading">loading...</Loading>}
      {program && (
        <Flex>
          <ImageContainer>
            {program.id === "rechXN2XoYFjlEVm3" ? (
              <Essay className="statement">
                <h3>Reflections of the Rinehart Cohort</h3>

                <p>
                  The sudden shift last year from working in Rinehart’s spacious
                  studios to converting whatever areas that were available in
                  our homes was as strange and disruptive for us as equivalent
                  shifts were for millions around the world. Usually when we
                  encounter change, we look to others that have gone through the
                  same issue for guidance. But when it’s a problem that no one
                  has ever encountered, what do we do? While some chose to step
                  back and care for themselves and loved ones during this
                  tumultuous time, others decided to push through. Yang Liu,
                  Lauren Hyde, Zewen Liu and EB Jauer chose to adapt and
                  persevere.
                </p>
                <p>
                  One of the reasons that the art of making sculpture seems like
                  a siren’s call to particular people is its existence in the
                  round. There is a strong sense of accomplishment when one is
                  able to envision an object in their mind’s eye and bring it to
                  being through skill, time, materials, and tools. Creating work
                  that occupies physical space and relates to the viewer’s body
                  is a distinct encounter not always present in other forms of
                  art.
                </p>
                <p>
                  There is a critical element missing in the experience of
                  sculpture when it’s not possible for the audience to
                  physically encounter the work. Images and video are somewhat
                  capable, but there is no true substitute for seeing it in
                  person.The work created by these four committed artists
                  demonstrates their adaptation during this time. In their
                  living rooms, bedrooms, and basements they shifted their
                  process of creating. With the tools available, they moved
                  clay, polymers, paper, foam, plaster, wood, and metal into the
                  works you see here.
                </p>
                <p>
                  Yang focused on the phenomenology of everyday life and living.
                  His abstract forms are full of movement and incorporate light
                  as an essential material, thereby making the shadows integral
                  to the work. The pieces encompass the juxtaposition of the
                  fragility of foam and softness of circles against the
                  roughness of wood and sharp edges of city skylines. He is a
                  storyteller inviting the viewer into the story.
                </p>
                <p>
                  Lauren found solace and peace in the forest. Getting outside
                  and taking her art with her, she began to integrate her
                  passion for nature with her passion for porcelain clay. The
                  meticulous raw forms that she creates are nestled within holes
                  of long gone trees, temporarily breathing new life into them.
                  Left in place to disappear in their own time,these sculptures
                  raise questions about permanence, vicissitude and degradation.
                </p>
                <p>
                  Zewen made his way back to China and dove into fabricating
                  extravagant creatures influenced by mythology. Looking to
                  ancient stories of fantastical Norse animals, Greek gods, and
                  Chinese creation myths, he uses digital drawing, 3D printing,
                  clay sculpting, and mold making to bring these extraordinarily
                  detailed and intricate creatures to life. This assemblage of
                  highly figurative, dynamic sculptures incorporate animal and
                  human elements into their own mythologies.
                </p>
                <p>
                  EB synthesizes modernists of yesterday and takes them along
                  with her on a journey of deep reflection. She pulls elegant
                  forms out of the world’s most natural materials, such as stone
                  and exotic woods. However, these forms are contemporized with
                  the materials and found objects of today. Aluminum, cording,
                  and gestural tree segments swing into atmospheric geometries
                  reflecting the unease she experiences. Like abstract art of
                  all eras and genres, the message of the work is often quiet,
                  gradually revealing itself through form, leaving viewers to
                  relate their own emotions to it.
                </p>
                <p>
                  The diversity of form, technique, content, and materials seen
                  here are testament to the broad scope of the art of sculpture.
                  With these images, we invite you to reflect on your time this
                  past year as we have reflected on ours. Being able to continue
                  to create during adversity and rise to challenges leaves us
                  with remarkable memories not only of our last year here, but
                  of our unparalleled time at MICA.
                </p>
              </Essay>
            ) : (
              profileImg && <img src={profileImg.url} />
            )}
            {!profileImg && <NoImages />}
            {program && program.profileCaption && (
              <Description
                className="statement"
                dangerouslySetInnerHTML={{
                  __html: marked(program.profileCaption),
                }}
              />
            )}
            {/* {program.art && program.art.length > 0 && (
              <ImageStack collection={program.art} />
            )}
            {program.art && program.art.length > 0 && (
              <ImageHeaderMobile collection={program.art} />
            )}
            {!program.art && <NoImages />} */}
          </ImageContainer>

          <InfoContainer>
            <StudentInfo {...program} />
            <Divider />
            <ProgramList id={program.id} />
            {program.art && program.art.length > 0 && (
              <ImageStackMobile collection={program.art} />
            )}
          </InfoContainer>
        </Flex>
      )}
      {picked && picked.length > 0 && <SlideTitle>Student Work</SlideTitle>}
      {picked && picked.length > 0 && <Slideshow collection={picked} />}
    </Wrapper>
  );
}

ProgramDetail.propTypes = {
  closePopup: PropTypes.func.isRequired,
  program: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};
ProgramDetail.defaultProps = {
  program: null,
};
export default ProgramDetail;



// WEBPACK FOOTER //
// ./src/components/ProgramsDetail/ProgramsDetailEl.jsx